import { Column } from 'typeorm';
import { PageInfo } from 'src/app/core/models/page-info';
import { RegistrationFormComponent } from '../registration-form.component';
import { Component, EventEmitter, Injector, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FileUpload } from 'primeng/fileupload';
import { DropdownOptionsService } from 'src/app/core/services/dropdown-options.service';
import { WarehousingRegistrationService } from '../../../services/warehousing-registration.service';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';
import { FacilityOptions } from 'src/app/core/models/options/facility-options';
import { FacilityService } from 'src/app/core/services/facility.service';
import { LaasOption } from 'src/app/core/models/laas-option';
import { getDataScopeByPermission } from 'src/app/core/utils/common-functions';
import { PermissionConstants } from 'src/app/core/constants/permission-constants.constant';

@Component({
  selector: 'laas-registration-import',
  templateUrl: './registration-import.component.html',
  styleUrls: ['./registration-import.component.scss']
})
export class RegistrationImportComponent extends SessionBaseComponent implements OnInit {

  readonly permissionCode: PermissionConstants = PermissionConstants.ViewRegistrationFormSearch;
  @Output() visibleChange: EventEmitter<any>;
  @ViewChild('fileUpload') fileUpload!: FileUpload;

  pageInfo: PageInfo;
  isVisible: boolean = false;
  isLoading: boolean = false;
  isSaveing: boolean = false;
  resultRows: any[] = [];
  columns: any[];
  facilityOptions:any[]=[];
  forwarderOptions:any[]=[];
  orgOptions: Array<LaasOption> = [];

  constructor(injector: Injector,
    private warehousingRegistrationService:WarehousingRegistrationService,
    private dropdownOptionsService: DropdownOptionsService,
    private facilityService: FacilityService) {

    super(injector);
    this.visibleChange = new EventEmitter<any>();
    this.columns =[
      {field:'registrationKey',header:'RegistrationFormSearch.MainTable.Registrationkey',sort:true},
      {field:'forwarderCode',header:'RegistrationFormSearch.MainTable.Forwarder',sort:true},
      {field:'vendorName',header:'RegistrationFormSearch.MainTable.Vendor',sort:true},
      {field:'orgId',header:'RegistrationFormSearch.MainTable.Org',sort:true},
      {field:'referenceKey',header:'RegistrationFormSearch.MainTable.Referencekey',sort:true},
      {field:'referenceType',header:'RegistrationFormSearch.MainTable.ReferenceType',sort:true},
      {field:'palletCnt',header:'RegistrationFormSearch.MainTable.PalletCnt',sort:true},
      {field:'totalCtn',header:'RegistrationFormSearch.MainTable.TotalCartonNo',sort:true},
      {field:'edc', header: 'RegistrationFormSearch.MainTable.EDC', sort: true },
      {field:'isArrived',header:'RegistrationFormSearch.MainTable.IsArrived',sort:true}
    ]

    this.pageInfo = {
      pageSize: 5,
      pageIndex: 0,
      totalRecords: 0,
      totalPages: 0,
    };

    this.dropdownOptionsService.getForwarderOptions().subscribe({
      next: result => {
        this.forwarderOptions = result.map((x: any) => {
          return {
            label: `${x.optionDesc}`,
            value: x.optionCode,
          };
        });
      },
    });

    this.dropdownOptionsService.getFacilityOptions().subscribe({
      next: (options: FacilityOptions[]) => {
        this.facilityOptions = options.map((x) => ({
          label: x.optionDesc,
          value: x.optionCode,
        }));
      },
    });

    this.facilityService.getLetterOrgOptions(this.laasSetting.facility, "")
      .subscribe({
        next: (options: any[]) => {
          this.orgOptions = [...options].map((x: any) => {
            return {
              label: `${x.legalEntityOUCode}-${x.legalEntityOUName} (${x.legalEntityReferenceCode})`,
              value: x.legalEntityOUCode,
              source: x
            };
          });
        }
      });
  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();
  }

  @Input() get visible(): any {
    return this.isVisible;
  }

  set visible(value: any) {
    this.isVisible = value;
  }

  fileUploader(event: any): void {
    let files: any = event?.files;
    if (!files || files.length === 0) {
      this.toastService.warn(this.translateService.instant('IntransitImport.Message.SelectFile'));
      return;
    }

    // Reset table
    this.resultRows.length = 0;


    // Upload file
    this.isLoading = true;
    this.warehousingRegistrationService.importRegistrationExcel(files[0])
    .subscribe({
        next: (result) => {
          this.resultRows = result || [];
          console.log(result);
        },
        error: (err) => {
          this.isLoading = false;
          this.fileUpload.clear();
          this.toastErrorMessage(err.error);
        },
        complete: () => {
          this.isLoading = false;
          this.fileUpload.clear();
        }
      }
    );
  }

  saveBtnClick(event: any): void {

    if (!this.resultRows || this.resultRows.length === 0) {
      return;
    }

    this.isSaveing=true;
    this.warehousingRegistrationService.saveRegistration(this.resultRows)
      .subscribe({
        next: (result) => {
          this.dialogVisibleChange(false); // Close file upload dialog
          this.toastService.success("Saved successfully");
          //儲存後搜尋
          const dataScopes = getDataScopeByPermission(this.userProfile, this.permissionCode);
          this.routeStateService.navigateTo('/TransportOperation/RegistrationFormSearch', { registrationKeyList: result.registrationKeyList, dataScopes:dataScopes, errMsgs: [] });
        },
        error: (err) => {
          this.toastErrorMessage(err.error);
        },
        complete: () => {
          this.isSaveing=false;
        }
      });
  }

  dialogVisibleChange(value: boolean): void {
    this.visibleChange.emit(value);
  }

}

